import { useEffect, useState } from "react";
import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import CurrencyInput from "../../../../components/inputs/currency";
import SelectInput from "../../../../components/inputs/select";
import TextInput from "../../../../components/inputs/text";
import Installment from "../../../../components/installment/parameters";
import Loading from "../../../../components/loading";
import ModalMain from "../../../../components/modal";
import SearchSelectDynamic from "../../../../components/search";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import ShowTableInstallments from "../../../../components/installment/table/table-installments-show";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { RegisterSupplierProvider } from "../../../../components/register/register-fornecedor/context";
import { MainRegisterFornecedor } from "../../register-fornecedor";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
	reloadFetchFirstData,
}) => {
	//#region useForm
	const {
		//useForm
		register,
		control,
		errors,
		isSubmitting,

		setValue,
		handleSubmit,

		//Data
		categoryData,
		costCenterData,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//installment
		identModalInstallment,
		handleOpenModalinstallment,
		CallBackInstallments,

		//variables
		installments,
		valorTotal,
		loading,
		isInsert,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		reloadFetchFirstData,
		insert,
	});
	//#endregion

	const identModalSelectSupplier = "modalSelectSupplier";

	const handleOpenModalSelectSupplier = (e) => {
		if (e && e.preventDefault) e.preventDefault();
		const event = new CustomEvent(identModalSelectSupplier);
		window.dispatchEvent(event);
	};

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === "F2" && isInsert) {
				e.preventDefault();
				handleOpenModalSelectSupplier(e);
			}
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [isInsert]);

	const handleCloseModalSelectSupplier = () => {
		const event = new CustomEvent(identModalSelectSupplier);
		window.dispatchEvent(event);
	};

	const onSelectSupplier = (item) => {
		setValue("id_fornecedor", item.id_fornecedor || item.idTable || item.id || item.codigo, {
			shouldValidate: true,
		});
		setValue("nome_fornecedor", item.fantasia || item.nome, { shouldValidate: true });
		handleCloseModalSelectSupplier();

		setTimeout(() => {
			document.getElementById("valor")?.focus();
		}, 100);
	};


	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<>
					<form
						className="form"
						onSubmit={handleSubmit(
							handleOnSubmit,
							// handleOnError
						)}
					>
						<main className="overflow-auto">
							{/* se for cadastro mostra a tabela com a parcela atual */}
							{isInsert ? (
								<>
									<div className="row">
										<CurrencyInput
											label="Valor total da saída"
											name="valor"
											control={control}
											errors={errors}
											placeholder="Digite o preço"
											required={true}
											decimalScale={2}
											prefix="R$ "
											className={`col-6 col-sm-6 col-lg-2`}
											onKeyDown={libForm.EnterTab}
											truncate={true}
										/>

										<TextInput
											label="Descrição"
											id="descricao"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-7"
										/>

										<div className="col-12 d-flex align-items-end pb-3">
											<div className="flex-grow-1">
												<TextInput
													id="nome_fornecedor"
													label="Fornecedor Selecionado [Atalho: F2]"
													placeholder="Clique na lupa ou pressione F2..."
													register={register}
													errors={errors}
													disabled={true}
													className="col-12 mb-0"
												/>
											</div>
											<button
												type="button"
												className="btn btn-primary ms-2"
												style={{ height: "38px", marginBottom: "5px" }}
												onClick={handleOpenModalSelectSupplier}
												autoFocus={true}
												title="Buscar Fornecedor (F2)"
											>
												<FontAwesomeIcon icon={faSearch} />
											</button>
										</div>

										<SelectInput
											key="categoria-insert"
											label="Categoria"
											id="id_conta_tipo"
											labelSelect="nome"
											control={control}
											errors={errors}
											data={categoryData}
											setValue={setValue}
											onKeyDown={libForm.EnterTab}
											// handleSelect={handleSelectedState}
											// loading={loadingCities}
											className="col-12 col-sm-6 col-lg-4"
										/>
										<SelectInput
											label="Departamento de custo"
											id="id_centrocusto"
											labelSelect="nome"
											control={control}
											errors={errors}
											data={costCenterData}
											setValue={setValue}
											onKeyDown={libForm.EnterTab}
											// handleSelect={handleSelectedState}
											// loading={loadingCities}
											className="col-12 col-sm-6 col-lg-4"
										/>
										<TextInput
											label="Observações da saída"
											id="obs"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-12"
										/>
									</div>

									{/* Mostra as parcela no formulario principal recebe as parcelas e o control para alterar a tabela */}
									<ShowTableInstallments
										installments={installments}
										control={control}
										setValue={setValue}
									/>

									<div className="flex justify-end me-1">
										<button
											type="button"
											className="btn btn-primary btn-sm ms-1 mt-4"
											onClick={handleOpenModalinstallment}
											onKeyDown={libForm.EnterTab}
										>
											Parcelar
										</button>
									</div>
								</>
							) : (
								<>
									<div className="row">
										<TextInput
											label="Descrição"
											id="descricao"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-7"
										/>

										<div className="col-12 d-flex align-items-end pb-3">
											<div className="flex-grow-1">
												<TextInput
													id="nome_fornecedor"
													label="Fornecedor"
													placeholder="Fornecedor selecionado na criação"
													register={register}
													errors={errors}
													disabled={true}
													className="col-12 mb-0"
												/>
											</div>
										</div>

										<SelectInput
											key="categoria-edit"
											label="Categoria"
											id="id_conta_tipo"
											labelSelect="nome"
											control={control}
											errors={errors}
											data={categoryData}
											setValue={setValue}
											onKeyDown={libForm.EnterTab}
											// handleSelect={handleSelectedState}
											// loading={loadingCities}
											className="col-12 col-sm-6 col-lg-4"
										/>

										<SelectInput
											label="Departamento de custo"
											id="id_centrocusto"
											labelSelect="nome"
											control={control}
											errors={errors}
											data={costCenterData}
											setValue={setValue}
											onKeyDown={libForm.EnterTab}
											// handleSelect={handleSelectedState}
											// loading={loadingCities}
											className="col-12 col-sm-6 col-lg-4"
										/>
										<TextInput
											label="Observações da saída"
											id="obs"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-7 col-lg-12"
										/>

										<div className="border-bottom mt-3 mb-3">Dados da Parcela</div>

										<ShowTableInstallments
											installments={installments}
											control={control}
											setValue={setValue}
										/>
									</div>
								</>
							)}
						</main>

						<div className="flex justify-between flex-row-reverse p-1">
							<BtnSubmit text="Salvar" isSubmitting={isSubmitting} />
							<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						</div>
					</form>
				</>
			)}

			{/* Modal para selecionar parcelamento e dadas de pagamento passando o valor total e esperando de volta o Data do formulario*/}
			<ModalMain
				ident={identModalInstallment}
				overlayClassName="react-modal-overlay"
				className="react-modal-content-base w-full max-w-[1050px] h-[90%] bg-white p-4 relative m-10"
			>
				<Installment installmentValue={valorTotal} CallBackInstallments={CallBackInstallments} />
			</ModalMain>

			{/* Modal de Seleção de Fornecedor */}
			<ModalMain
				ident={identModalSelectSupplier}
				className="react-modal-content-base w-full max-w-[1250px] h-[95%] bg-white p-4 relative m-10"
			>
				<RegisterSupplierProvider>
					<MainRegisterFornecedor isSelector={true} onSelectSupplier={onSelectSupplier} />
				</RegisterSupplierProvider>
			</ModalMain>
		</>
	);
};

export default Form;
